"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLegacyAddressFromPrivateKey = exports.getLegacyAddressFromPassphrase = exports.getLegacyAddressAndPublicKeyFromPassphrase = exports.getLegacyAddressFromPublicKey = void 0;

var hash_1 = require("./hash");

var keys_1 = require("./keys");

var convert_1 = require("./convert");

var nacl_1 = require("./nacl");

var getLegacyAddressFromPublicKey = function getLegacyAddressFromPublicKey(publicKey) {
  var publicKeyHash = hash_1.hash(publicKey);
  var publicKeyTransform = convert_1.getFirstEightBytesReversed(publicKeyHash);
  return "".concat(publicKeyTransform.readBigUInt64BE().toString(), "L");
};

exports.getLegacyAddressFromPublicKey = getLegacyAddressFromPublicKey;

var getLegacyAddressAndPublicKeyFromPassphrase = function getLegacyAddressAndPublicKeyFromPassphrase(passphrase) {
  var _keys_1$getKeys = keys_1.getKeys(passphrase),
      publicKey = _keys_1$getKeys.publicKey;

  var address = exports.getLegacyAddressFromPublicKey(publicKey);
  return {
    address: address,
    publicKey: publicKey
  };
};

exports.getLegacyAddressAndPublicKeyFromPassphrase = getLegacyAddressAndPublicKeyFromPassphrase;

var getLegacyAddressFromPassphrase = function getLegacyAddressFromPassphrase(passphrase) {
  var _keys_1$getKeys2 = keys_1.getKeys(passphrase),
      publicKey = _keys_1$getKeys2.publicKey;

  return exports.getLegacyAddressFromPublicKey(publicKey);
};

exports.getLegacyAddressFromPassphrase = getLegacyAddressFromPassphrase;

var getLegacyAddressFromPrivateKey = function getLegacyAddressFromPrivateKey(privateKey) {
  var publicKey = nacl_1.getPublicKey(privateKey);
  return exports.getLegacyAddressFromPublicKey(publicKey);
};

exports.getLegacyAddressFromPrivateKey = getLegacyAddressFromPrivateKey;